const SecurityDisclaimer = () => {
  return (
    <div className="trustben-securities-disclaimer">
      Securities of Beneficient, a Nevada corporation, its affiliates and/or successors are
      offered through AltAccess Securities Company, L.P., an affiliated entity. Member{" "}
      <a href="https://www.finra.org/" target="_blank" rel="noopener noreferrer">
        FINRA/SIPC
      </a>
      .
    </div>
  );
};

export default SecurityDisclaimer;
